
<div class="p-3 rounded bg-gray-100 dark:bg-gray-800 mt-3">
  <div class="flex items-center justify-between mb-2">
    <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ file.name }}</span>
    <span class="text-xs text-gray-500 dark:text-gray-400">{{ formatFileSize(file.size) }}</span>
  </div>

  <!-- Barra de progreso -->
  <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mb-2">
    <div 
      class="bg-blue-500 h-2 rounded-full transition-all duration-300"
      [style.width.%]="percentage"
    ></div>
  </div>

  <!-- Estado y acciones -->
  <div class="flex justify-between items-center text-sm">
    <div class="text-gray-600 dark:text-gray-400">
      <span *ngIf="isUploading">Subiendo... {{ percentage }}%</span>
      <span *ngIf="isCompleted" class="text-green-600 dark:text-green-400">
        <i class="mdi mdi-check-circle mr-1"></i>Completado
      </span>
      <span *ngIf="isError" class="text-red-600 dark:text-red-400">
        <i class="mdi mdi-alert-circle mr-1"></i>{{ errorMessage }}
      </span>
    </div>

    <div *ngIf="isCompleted && downloadURL">
      <a 
        class="text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 text-xs"
        [href]="downloadURL" 
        target="_blank" 
        rel="noopener"
      >
        <i class="mdi mdi-download mr-1"></i>Descargar
      </a>
    </div>
  </div>
</div>
